export default "__VITE_ASSET__BdBeXkYO__"